import * as cohort from '../../actionTypes/Cohort/Cohort';

const initialSelectionState = {
  CohortsSelections: {
    numberSelectionsMinRequired: 5,
    numberSelectionsMaxAllowed: 10,
  },
};

export default function cohortsSelectionsReducer(state = initialSelectionState, action) {
  switch (action.type) {
    case cohort.GET_COHORT_SELECTION_LIMIT:
      return { ...state, CohortsSelections: action.cohortsSelections };
    default:
      return state;
  }
}
